import { createTheme } from "@mui/material";
import { yellow } from "@mui/material/colors";

export const LightTheme = createTheme({
    palette:{
        mode:"light",
        primary:{
            main: yellow[700],
            dark:yellow[800],
            light: yellow[500],
            contrastText: "#ffffff"
        },
        secondary:{
            main: yellow[700],
            dark:yellow[800],
            light: yellow[500],
            contrastText: "#ffffff"
        },
        background:{
            paper:"#E3E3E0",
            default: "#f7f6f3"
        }
    },
    typography: {
        allVariants: {
          fontFamily: "'Arial', 'sans-serif', 'Montserrat' ",
          textTransform: "none",
        }
    }       
});